import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      borderRadius: 4,
    },
  },
  variants: [
    {
      props: { variant: "contained" },
      style: {
        backgroundColor: Colors.GREY100,
        color: Colors.GREY500,
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.GREY100,
        },
      },
    },
    {
      props: { variant: "secondary" },
      style: {
        backgroundColor: "transparent",
        color: Colors.GREY500,
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.GREY100,
        },
      },
    },
    {
      props: { variant: "toolbar" },
      style: {
        color: Colors.WHITE,
        textTransform: "uppercase",
        fontSize: 14,
      },
    },
    {
      props: { variant: "transparent" },
      style: {
        color: Colors.WHITE,
        textTransform: "uppercase",
        fontSize: 24,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
    },
  ],
};
